import { loadRuntimeConfig } from '@giyus/api-client';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import './index.css';
import { AppProviders } from './app/providers';
import { buildUserManagerSettings } from './lib/auth/OidcAuthProvider';
import { runSilentCallback } from './lib/auth/silentCallback';
import { AUTH_SILENT_CALLBACK_PATH } from './lib/auth/types';
import { env, resolveAppEnv } from './lib/env';
import { browserI18nHost, initAppI18n } from './lib/i18n';

async function bootstrap(): Promise<void> {
  // Parte 14.8: o host (Giyus.Web) serve /config.json a partir dos app settings; em dev (vite) não existe → .env.
  const appEnv = resolveAppEnv(env, await loadRuntimeConfig());

  if (window.location.pathname === AUTH_SILENT_CALLBACK_PATH) {
    // Iframe da renovação silenciosa (oidc-client-ts): só entrega a resposta à janela pai — nunca monta o shell.
    await runSilentCallback(
      buildUserManagerSettings({
        authority: appEnv.oidcAuthority,
        clientId: appEnv.oidcClientId,
        origin: window.location.origin,
      }),
    );
    return;
  }

  const i18n = await initAppI18n(browserI18nHost());
  const container = document.getElementById('root');
  if (!container) {
    throw new Error('Root element #root not found.');
  }
  createRoot(container).render(
    <StrictMode>
      <AppProviders i18n={i18n} env={appEnv} />
    </StrictMode>,
  );
}

void bootstrap();
